import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { connect } from "react-redux";

import Login from "./view";

import { handleResp } from "shared/method";
import { logIn, sendSmsVerifyCode, verifyPhone } from "store/actions/session";
import "./login.scss";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  logIn: async (loginDetails) => await handleResp(dispatch, logIn, loginDetails),
  sendSmsVerifyCode: async (params) => {
    if (!params.phoneNumber) return { success: false };
    return await handleResp(undefined, sendSmsVerifyCode, params);
  },
  verifyPhone: async (params) => await handleResp(undefined, verifyPhone, params)
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Login));
